import type { ButtonHTMLAttributes } from 'react'
import { Zap } from 'lucide-react'
import styles from './trade-panel.module.css'

export default function InstantSellButton({ children = 'Instant Sell', className = '', ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
 return <button type="button" {...props} className={`${styles.marketAction} ${className}`}><Zap size={13} className="fill-current" aria-hidden="true" />{children}</button>
}
